import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import { LeaveTypeId } from '@/types/request';

export default {
  namespaced: true,
  state: {
    leaveTypes: [],
    selectedLeaveTypes: [] as LeaveTypeId[],
  },
  mutations: {
    set(state: any, payload: any) {
      state.leaveTypes = payload;
    },
    setSelected(state: any, payload: LeaveTypeId[]) {
      state.selectedLeaveTypes = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    resetLeaveTypes({ commit }: {commit: any}): void {
      commit('set', []);
    },
    updateLeaveTypes({ commit, state }: {commit: any, state: any}, { force }: { force: boolean }): void {
      if (state.leaveTypes.length && !force ) { return; }
      request('get', `leave-types` )
      .then((response: AxiosResponse) => {
        commit('set', response.data);
      });
    },
  },
  getters: {
    list: (state: any): object[] => state.leaveTypes,
    selected: (state: any): LeaveTypeId[] => state.selectedLeaveTypes,
  },
};

